// extracted by mini-css-extract-plugin
export default {"greeting":"OrderInformation_greeting__s6VBz","header":"OrderInformation_header__OGIoH","btn":"OrderInformation_btn__JoxxA"};